import angular from 'angular'

angular.module('nominas.fondoreserva')
  .service('NominasFondoReservaNominasNomina', NominasFondoReservaNominasNomina);

function NominasFondoReservaNominasNomina($http) {
  this.get = _get;

  function _get(idProyecto, idNomina) {
    return $http.get('api/nominas/fondo-reserva/nominas/nomina', {
      params: {
        id_proyecto: idProyecto,
        id_nomina: idNomina,
      },
      schema: NominasFondoReservaNominasNominaSchema,
    });
  }
}

let NominasFondoReservaNominasNominaSchema = {
  Fecha: 'date',
  Fecha_Final: 'date',
  Fecha_Inicial: 'date',
  Fecha_Pago: 'date',
  Terminado: 'boolean',
  Registros: {
    Status: 'boolean',
    Saldo: 'number',
    Fondo_Reserva: 'number',
    Fondo_Reserva_Saldo: 'number',
    Fondo_Reserva_Retencion: 'number',
    Comision_Porcentaje: 'number',
    Subtotal: 'number',
    Comision: 'number',
    Total: 'number',
  },
  Servicios: {
    Fecha_Movimiento: 'date',
    Importe: 'number',
    Status: 'boolean',
  },
};



// WEBPACK FOOTER //
// ./src/nominas/fondoreserva/services/FondoReserva/Nominas/Nomina.js